import { render } from "./approval_decision.vue?vue&type=template&id=5cff205a&scoped=true"
import script from "./approval_decision.vue?vue&type=script&lang=js"
export * from "./approval_decision.vue?vue&type=script&lang=js"

import "./approval_decision.vue?vue&type=style&index=0&id=5cff205a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cff205a"]])

export default __exports__